var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIptv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 43,
    fill: "white",
    stroke: "#F68140",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.2104 57.9568C59.1346 57.5536 59.5686 58.9973 58.7838 59.3284C57.8529 59.7315 57.1782 58.4162 58.2104 57.9568ZM55.9931 38.3196C59.2763 39.2971 62.004 42.4187 62.1772 45.7835V58.3104C62.1322 60.3779 61.4261 62.5175 59.9262 63.9995C56.5148 67.3778 54.1582 66.8148 49.0828 66.8148H35.4352C30.2901 66.8148 26.5168 65.3396 25.217 59.932C24.8662 58.477 25.0506 49.047 25.0326 46.538C25.0124 42.5741 27.2948 39.6822 30.9423 38.4097C32.6693 37.8106 53.7759 37.662 55.9931 38.3196ZM41.7587 42.2205C45.3859 41.966 48.7635 42.4187 51.9567 43.4727C55.8762 44.7745 56.9489 45.4389 56.3305 50.2654C55.9347 53.3735 55.1948 56.9185 54.2774 59.7338C53.569 61.9117 53.6072 62.1211 51.1359 62.3576C47.7965 62.6774 36.8317 62.8756 34.5043 62.1662C33.2989 61.7968 32.9751 59.6437 32.5726 58.3284C32.1206 56.8352 31.7496 55.2586 31.437 53.6933C31.1244 52.1235 30.8051 50.2452 30.7421 48.5853C30.6657 46.4457 31.1559 45.3218 32.5344 44.5628C34.8236 43.2925 38.7814 42.4299 41.7587 42.2205Z",
    fill: "#071E43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.355 59.469L34.6428 60.5028C37.0512 60.6942 41.1124 59.4758 43.0373 58.7348C47.0019 57.1898 49.5452 55.4916 52.6237 52.9894C53.0892 52.6065 54.9174 50.8633 55.1603 50.4218C55.6887 49.4826 55.8169 46.9106 55.1535 46.1133C54.733 45.6156 52.5585 44.6696 51.533 44.5683C51.2834 45.1561 50.3592 46.3746 49.9454 46.9624C49.3968 47.7349 48.8098 48.5255 48.2117 49.2281C47.3819 50.2124 46.3115 51.4691 45.376 52.3362C39.5428 57.7573 35.1128 58.8609 34.355 59.4668V59.469Z",
    fill: "url(#paint0_linear_298_1078)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6467 57.1448L33.9391 58.2619C35.9269 58.0007 40.5368 54.9174 42.41 53.4602C44.1438 52.1201 45.7944 50.3521 47.2088 48.6855L48.9179 46.5842C49.2934 46.0729 50.2626 44.7644 50.4605 44.19C48.9426 43.6788 46.6804 43.2711 44.8904 43.3207C44.5778 43.6856 43.2196 46.3207 42.6282 47.2598C41.7489 48.6517 40.3727 50.5728 39.345 51.7868L37.8406 53.4399C37.5528 53.7215 37.2919 53.9197 37.0176 54.1922C35.4682 55.7507 36.0686 55.1178 34.5192 56.4331C34.2584 56.6493 33.9211 56.9827 33.6467 57.1426V57.1448Z",
    fill: "url(#paint1_linear_298_1078)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6641 60.9556C39.7405 61.0006 39.6506 60.9803 39.8687 61.0457C39.9699 61.0772 39.9969 61.0839 40.0846 61.0975C41.0988 61.2574 48.0203 61.0389 48.3959 61.0276C49.5113 60.9894 52.3289 61.0794 52.8709 60.4015C53.4263 59.7056 54.924 53.6088 55.0117 52.307C54.762 52.4467 52.7989 54.3948 51.8634 55.1156C50.7616 55.9579 49.5495 56.852 48.2497 57.5412C46.8915 58.2619 45.7131 58.8565 44.2402 59.4826C42.7561 60.1087 41.2247 60.4713 39.6641 60.9578V60.9556Z",
    fill: "url(#paint2_linear_298_1078)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3924 55.9061C34.7371 55.2237 38.1215 51.5773 39.1672 50.3071C39.9565 49.3566 43.3498 44.6112 43.5904 43.1945L38.9693 43.7058C38.6702 43.8072 38.7781 43.7576 38.6702 44.127C37.8426 46.8859 35.3173 51.4377 33.597 53.7485C33.0866 54.4309 32.756 55.0705 33.3924 55.9061Z",
    fill: "url(#paint3_linear_298_1078)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8123 53.0728L34.1503 50.9534C35.0228 49.5052 37.4334 45.4445 37.5279 44.0526C36.0617 44.2891 32.7403 45.4445 32.2298 46.4332C31.6362 47.5886 32.2096 52.1854 32.81 53.0728H32.8123Z",
    fill: "url(#paint4_linear_298_1078)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.191 29.1757L33.8522 28.8063L40.1441 37.9661L38.4935 38.8805L33.191 29.1757Z",
    fill: "#071E43"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.66 25.4347L47.8707 25L38.896 37.9232L41.2414 39.2048L48.66 25.4347Z",
    fill: "#071E43"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9346 29.2207C33.6812 29.2207 34.2861 28.6149 34.2861 27.8672C34.2861 27.1194 33.6812 26.5136 32.9346 26.5136C32.188 26.5136 31.5831 27.1194 31.5831 27.8672C31.5831 28.6149 32.1948 29.2207 32.9346 29.2207Z",
    fill: "#071E43"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.0694 25.5945C50.0521 25.5945 50.8617 24.7837 50.8617 23.795C50.8617 22.8063 50.0521 22 49.0694 22C48.0867 22 47.2727 22.804 47.2727 23.795C47.2727 24.786 48.0822 25.5945 49.0694 25.5945Z",
    fill: "#071E43"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.4824 59.5648C58.9614 59.5648 59.3504 59.1752 59.3504 58.6954C59.3504 58.2157 58.9614 57.8261 58.4824 57.8261C58.0034 57.8261 57.6144 58.2157 57.6144 58.6954C57.6144 59.1752 58.0034 59.5648 58.4824 59.5648Z",
    fill: "#FEFEFE",
    stroke: "#FEFEFE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0192 61.6144C58.3385 61.6144 58.5926 61.3599 58.5926 61.0469C58.5926 60.7338 58.3385 60.4793 58.0192 60.4793C57.6999 60.4793 57.4525 60.7338 57.4525 61.0469C57.4525 61.3599 57.7066 61.6144 58.0192 61.6144Z",
    fill: "#FEFEFE",
    stroke: "#FEFEFE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_298_1078",
    x1: 44.98,
    y1: 44.5683,
    x2: 44.98,
    y2: 60.5229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD5900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE3D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_298_1078",
    x1: 42.0536,
    y1: 43.3166,
    x2: 42.0536,
    y2: 58.2619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCC905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDEBA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_298_1078",
    x1: 47.3379,
    y1: 52.307,
    x2: 47.3379,
    y2: 61.1558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC0001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57D7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_298_1078",
    x1: 38.3164,
    y1: 43.1945,
    x2: 38.3164,
    y2: 55.9061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69A711"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1E4B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_298_1078",
    x1: 35.6091,
    y1: 42.9042,
    x2: 32.5605,
    y2: 53.3563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#168CBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EC7DF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIptv);
export default __webpack_public_path__ + "static/media/iptv.12ccfe65a38b9e166f32ab74ab3c966e.svg";
export { ForwardRef as ReactComponent };